import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestTokensUpdateVisibility } from '@shared/common/_requests/request_tokens_update_visibility';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { update_search_locally } from '../_methods/update_search_locally';
import { StateSearch } from '../state_search';

export const remote_search_tokens_update_visibility = createAsyncThunkSafe<void, RequestTokensUpdateVisibility>(
  ENUM__network_event_client_to_server.SEARCH_TOKENS_UPDATE_VISIBILITY,
  async (request): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.SEARCH_TOKENS_UPDATE_VISIBILITY, request);
  },
);

export function init_remote_search_tokens_update_visibility(builder: ActionReducerMapBuilder<StateSearch>) {
  builder
    .addCase(remote_search_tokens_update_visibility.pending, (state, action) => {
      let request: RequestTokensUpdateVisibility = action.meta.arg;
      let search_id = request.entity_id;

      let search = state.search_history_map.get_or_assert(search_id, { context: 'search' });

      let tokens_new = [...search.tokens];

      for (let item_new of request.tokens) {
        tokens_new = tokens_new.map(item_saved => (item_saved.is_equal(item_new) ? item_saved.clone({ is_hidden: item_new.is_hidden }) : item_saved));
      }

      search = search.clone({ tokens: tokens_new });

      update_search_locally(state, search);
    })
    .addCase(remote_search_tokens_update_visibility.rejected, (state, action) => {})
    .addCase(remote_search_tokens_update_visibility.fulfilled, (state, action: PayloadAction) => {});
}
